// profanity filter - https://github.com/web-mech/badwords#readme
const localList = ["ahole","anus","ash0le","ash0les","asholes","ass","Ass Monkey","Assface","assh0le","assh0lez","asshole","assholes","assholz","asswipe","azzhole","antifa", "BLM", "black lives matter", "bassterds","bastard","bastards","bastardz","basterds","basterdz","Biatch","bitch","bitches","Blow Job","boffing","butthole","buttwipe","c0ck","c0cks","c0k","Carpet Muncher","cawk","cawks","Clit","cnts","cntz","cock","cockhead","cock-head","cocks","CockSucker","cock-sucker","crap","cum","cunt","cunts","cuntz","dick","dild0","dild0s","dildo","dildos","dilld0","dilld0s","dominatricks","dominatrics","dominatrix","dyke","enema","f u c k","f u c k e r","fag","fag1t","faget","fagg1t","faggit","faggot","fagg0t","fagit","fags","fagz","faig","faigs","fart","flipping the bird","fuck","fuckin","fucking","fucks","Fudge Packer","fuk","Fukah","Fuken","fuker","Fukin","Fukk","Fukkah","Fukken","Fukker","Fukkin","g00k","God-damned","h00r","h0ar","h0re","hells","hoar","hoor","hoore","jackoff","jap","japs","jerk-off","jisim","jiss","jizm","jizz","knob","knobs","knobz","kunt","kunts","kuntz","Lezzian","Lipshits","Lipshitz","masochist","masokist","massterbait","masstrbait","masstrbate","masterbaiter","masterbate","masterbates","n1gr","nastt","nigger;","nigur;","niiger;","niigr;","orafis","orgasim;","orgasm","orgasum","oriface","orifice","orifiss","packi","packie","packy","paki","pakie","paky","pecker","peeenus","peeenusss","peenus","peinus","pen1s","penas","penis","penis-breath","penus","penuus","Phuc","Phuck","Phuk","Phuker","Phukker","polac","polack","polak","Poonani","pr1c","pr1ck","pr1k","pusse","pussee","pussy","puuke","puuker","queer","queers","queerz","qweers","qweerz","qweir","recktum","rectum","retard","sadist","scank","schlong","screwing","semen","sex","sexy","Sh!t","sh1t","sh1ter","sh1ts","sh1tter","sh1tz","shit","shits","shitter","Shitty","Shity","shitz","Shyt","Shyte","Shytty","Shyty","skanck","skank","skankee","skankey","skanks","Skanky","slag","slut","sluts","Slutty","slutz","son-of-a-bitch","tit","turd","va1jina","vag1na","vagiina","vagina","vaj1na","vajina","vullva","vulva","w0p","wh00r","wh0re","whore","xrated","xxx","b!+ch","bitch","blowjob","clit","arschloch","fuck","shit","ass","asshole","b!tch","b17ch","b1tch","bastard","bi+ch","boiolas","buceta","c0ck","cawk","chink","cipa","clits","cock","cum","cunt","dildo","dirsa","ejakulate","fatass","fcuk","fuk","fux0r","hoer","hore","jism","kawk","l3itch","l3i+ch","lesbian","masturbate","masterbat*","masterbat3","s.o.b.","mofo","nazi","nigga","nigger","nutsack","phuck","pimpis","pusse","pussy","scrotum","sh!t","shemale","shi+","sh!+","slut","smut","teets","tits","boobs","b00bs","teez","testical","testicle","titt","w00se","jackoff","wank","whoar","whore","*damn","*dyke","*fuck*","*shit*","@$$","amcik","andskota","arse*","assrammer","ayir","bi7ch","bitch*","bollock*","breasts","butt-pirate","cabron","cazzo","chraa","chuj","Cock*","cunt*","d4mn","daygo","dego","dick*","dike*","dupa","dziwka","ejackulate","Ekrem*","Ekto","enculer","faen","fag*","fanculo","fanny","feces","feg","Felcher","ficken","fitt*","Flikker","foreskin","Fotze","Fu(*","fuk*","futkretzn","gook","guiena","h0r","h4x0r","helvete","hoer*","honkey","Huevon","hui","injun","jizz","kanker*","kike","klootzak","kraut","knulle","kuk","kuksuger","Kurac","kurwa","kusi*","kyrpa*","lesbo","mamhoon","masturbat*","merd*","mibun","monkleigh","mouliewop","muie","mulkku","muschi","nazis","nepesaurio","nigger*","orospu","paska*","perse","picka","pierdol*","pillu*","pimmel","piss*","pizda","poontsee","poop","porn","p0rn","pr0n","preteen","pula","pule","puta","puto","qahbeh","queef*","rautenberg","schaffer","scheiss*","schlampe","schmuck","screw","sh!t*","sharmuta","sharmute","shipal","shiz","skribz","skurwysyn","sphencter","spic","spierdalaj","splooge","suka","b00b*","testicle*","titt*","twat","vittu","wank*","wetback*","wichser","wop*","yed","zabourah"];
// bad words list - https://github.com/web-mech/badwords-list
const baseList = ["4r5e", "5h1t", "5hit", "a55", "anal", "anus", "ar5e", "arrse", "arse", "ass", "ass-fucker", "asses", "assfucker", "assfukka", "asshole", "assholes", "asswhole", "a_s_s", "b!tch", "b00bs", "b17ch", "b1tch", "ballbag", "balls", "ballsack", "bastard", "beastial", "beastiality", "bellend", "bestial", "bestiality", "bi+ch", "biatch", "bitch", "bitcher", "bitchers", "bitches", "bitchin", "bitching", "bloody", "blow job", "blowjob", "blowjobs", "boiolas", "bollock", "bollok", "boner", "boob", "boobs", "booobs", "boooobs", "booooobs", "booooooobs", "breasts", "buceta", "bugger", "bum", "bunny fucker", "butt", "butthole", "buttmuch", "buttplug", "c0ck", "c0cksucker", "carpet muncher", "cawk", "chink", "cipa", "cl1t", "clit", "clitoris", "clits", "cnut", "cock", "cock-sucker", "cockface", "cockhead", "cockmunch", "cockmuncher", "cocks", "cocksuck", "cocksucked", "cocksucker", "cocksucking", "cocksucks", "cocksuka", "cocksukka", "cok", "cokmuncher", "coksucka", "coon", "cox", "crap", "cum", "cummer", "cumming", "cums", "cumshot", "cunilingus", "cunillingus", "cunnilingus", "cunt", "cuntlick", "cuntlicker", "cuntlicking", "cunts", "cyalis", "cyberfuc", "cyberfuck", "cyberfucked", "cyberfucker", "cyberfuckers", "cyberfucking", "d1ck", "damn", "dick", "dickhead", "dildo", "dildos", "dink", "dinks", "dirsa", "dlck", "dog-fucker", "doggin", "dogging", "donkeyribber", "doosh", "duche", "dyke", "ejaculate", "ejaculated", "ejaculates", "ejaculating", "ejaculatings", "ejaculation", "ejakulate", "f u c k", "f u c k e r", "f4nny", "fag", "fagging", "faggitt", "faggot", "faggs", "fagot", "fagots", "fags", "fanny", "fannyflaps", "fannyfucker", "fanyy", "fatass", "fcuk", "fcuker", "fcuking", "feck", "fecker", "felching", "fellate", "fellatio", "fingerfuck", "fingerfucked", "fingerfucker", "fingerfuckers", "fingerfucking", "fingerfucks", "fistfuck", "fistfucked", "fistfucker", "fistfuckers", "fistfucking", "fistfuckings", "fistfucks", "flange", "fook", "fooker", "fuck", "fucka", "fucked", "fuckhead", "fuckheads", "fuckin", "fucking", "fuckings", "fuckingshitmotherfucker", "fuckme", "fucks", "fuckwhit", "fuckwit", "fudge packer", "fudgepacker", "fuk", "fuker", "fukker", "fukkin", "fuks", "fukwhit", "fukwit", "fux", "fux0r", "f_u_c_k", "gangbang", "gangbanged", "gangbangs", "gaylord", "gaysex", "goatse", "God", "god-dam", "god-damned", "goddamn", "goddamned", "hardcoresex", "heshe", "hoar", "hoare", "hoer", "homo", "hore", "horniest", "horny", "hotsex", "jack-off", "jackoff", "jap", "jerk-off", "jism", "jiz", "jizm", "jizz", "kawk", "knob", "knobead", "knobed", "knobend", "knobhead", "knobjocky", "knobjokey", "kock", "kondum", "kondums", "kum", "kummer", "kumming", "kums", "kunilingus", "l3i+ch", "l3itch", "labia", "lust", "lusting", "m0f0", "m0fo", "m45terbate", "ma5terb8", "ma5terbate", "masochist", "master-bate", "masterb8", "masterbat*", "masterbat3", "masterbate", "masterbation", "masterbations", "masturbate", "mo-fo", "mof0", "mofo", "muff", "n1gga", "n1gger", "nazi", "nigg3r", "nigg4h", "nigga", "niggah", "niggas", "niggaz", "nigger", "niggers", "nob", "nob jokey", "nobhead", "nobjocky", "nobjokey", "numbnuts", "nutsack", "orgasim", "orgasims", "orgasm", "orgasms", "p0rn", "pawn", "pecker", "penis", "penisfucker", "phonesex", "phuck", "phuk", "phuked", "phuking", "phukked", "phukking", "phuks", "phuq", "pigfucker", "pimpis", "piss", "pissed", "pisser", "pissers", "pisses", "pissflaps", "pissin", "pissing", "pissoff", "poop", "porn", "porno", "pornography", "pornos", "prick", "pricks", "pron", "pube", "pusse", "pussi", "pussies", "pussy", "pussys", "rectum", "retard", "rimjaw", "rimming", "s hit", "s.o.b.", "sadist", "schlong", "screwing", "scroat", "scrote", "scrotum", "semen", "sex", "sh!+", "sh!t", "sh1t", "shag", "shagger", "shaggin", "shagging", "shemale", "shi+", "shit", "shitdick", "shite", "shited", "shitey", "shitfuck", "shitfull", "shithead", "shiting", "shitings", "shits", "shitted", "shitter", "shitters", "shitting", "shittings", "shitty", "skank", "slut", "sluts", "smegma", "smut", "snatch", "son-of-a-bitch", "spac", "spunk", "s_h_i_t", "t1tt1e5", "t1tties", "teets", "teez", "testical", "testicle", "tit", "titfuck", "tits", "titt", "tittie5", "tittiefucker", "titties", "tittyfuck", "tittywank", "titwank", "tosser", "turd", "tw4t", "twat", "twathead", "twatty", "twunt", "twunter", "v14gra", "v1gra", "vagina", "viagra", "vulva", "w00se", "wang", "wank", "wanker", "wanky", "whoar", "whore", "willies", "willy", "xrated", "xxx"];
// badwords library - https://github.com/web-mech/badwords
class Filter {
/**
 * Filter constructor.
 * @constructor
 * @param {object} options - Filter instance options
 * @param {boolean} options.emptyList - Instantiate filter with no blacklist
 * @param {array} options.list - Instantiate filter with custom list
 * @param {string} options.placeHolder - Character used to replace profane words.
 * @param {string} options.regex - Regular expression used to sanitize words before comparing them to blacklist.
 * @param {string} options.replaceRegex - Regular expression used to replace profane words with placeHolder.
 * @param {string} options.splitRegex - Regular expression used to split a string into words.
 */
constructor(options = {}) {
    Object.assign(this, {
    list: options.emptyList && [] || Array.prototype.concat.apply(localList, [baseList, options.list || []]),
    exclude: options.exclude || [],
    splitRegex: options.splitRegex || /\b/,
    placeHolder: options.placeHolder || '*',
    regex: options.regex || /[^a-zA-Z0-9|\$|\@]|\^/g,
    replaceRegex: options.replaceRegex || /\w/g
    })
}

/**
 * Determine if a string contains profane language.
 * @param {string} string - String to evaluate for profanity.
 */
isProfane(string) {
    return this.list
    .filter((word) => {
        const wordExp = new RegExp(`\\b${word.replace(/(\W)/g, '\\$1')}\\b`, 'gi');
        return !this.exclude.includes(word.toLowerCase()) && wordExp.test(string);
    })
    .length > 0 || false;
}

/**
 * Determine if a string contains emoji.
 * @param {string} string - String to evaluate for emoji.
 */
isEmoji(string) {
  var emojiExp = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
  return emojiExp.test(string);
}

/**
 * Replace a word with placeHolder characters;
 * @param {string} string - String to replace.
 */
replaceWord(string) {
    return string
    .replace(this.regex, '')
    .replace(this.replaceRegex, this.placeHolder);
}

/**
 * Evaluate a string for profanity and return an edited version.
 * @param {string} string - Sentence to filter.
 */
clean(string) {
    return string.split(this.splitRegex).map((word) => {
    return this.isProfane(word) ? this.replaceWord(word) : word;
    }).join(this.splitRegex.exec(string)[0]);
}

/**
 * Add word(s) to blacklist filter / remove words from whitelist filter
 * @param {...string} word - Word(s) to add to blacklist
 */
addWords() {
    let words = Array.from(arguments);

    this.list.push(...words);

    words
    .map(word => word.toLowerCase())
    .forEach((word) => {
        if (this.exclude.includes(word)) {
        this.exclude.splice(this.exclude.indexOf(word), 1);
        }
    });
}

/**
 * Add words to whitelist filter
 * @param {...string} word - Word(s) to add to whitelist.
 */
removeWords() {
    this.exclude.push(...Array.from(arguments).map(word => word.toLowerCase()));
}
}

// instantiate the bad words and emoji filter
const filter = new Filter;

const engraveTypeHandler = (e) => {

    // set maximum character input
    const max = 30;
    const currentInput = e.target;
    const currentInputContainer = currentInput.parentElement;
    const currentValue = currentInput.value;
    const addToCartBtn = currentInput.closest('form').querySelector('#AddToCart');
    const mobileAdddToCartBtn = document.querySelector('.mob_addtocart_btn button[type="submit"]');

  	//hide "please add your engraving text" once the user begins typing
  	const engravingWarning = document.querySelector('.add-engraving-warning');
  	engravingWarning.classList.add('hide-warning');


    // filter profanity and emoji
    if(currentValue.length >= 0) {
        if(filter.isProfane(currentValue) || filter.isEmoji(currentValue)) {
            // bad word or emoji detected!
            currentInput.closest('.engrave-container').previousElementSibling.classList.add('show-warning');
            currentInput.dataset.containsProfanity = true;
            mobileAdddToCartBtn.disabled = true;
            mobileAdddToCartBtn.classList.add('disable');
        } else {
            // nice words only please
            currentInput.closest('.engrave-container').previousElementSibling.classList.remove('show-warning');
            currentInput.dataset.containsProfanity = false;
            mobileAdddToCartBtn.disabled = false;
            mobileAdddToCartBtn.classList.remove('disable');
        }
    }

    // if either of the inputs have a profanity in them, disable the add to cart button
    if(document.querySelector('input[data-contains-profanity="true"]')) {
        // for desktop
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('disable');
        // for mobile
        mobileAdddToCartBtn.disabled = true;
        mobileAdddToCartBtn.classList.add('disable');
    } else {
        // for desktop
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('disable')
        // for mobile
        mobileAdddToCartBtn.disabled = false;
        mobileAdddToCartBtn.classList.remove('disable');
    }

    if(currentValue.length <= max) {
        // show number of characters left while typing
        currentInputContainer.dataset.count = max - currentValue.length;

        // remove max-exceeded class when less than max
        if(currentInput.classList.contains('max-exceeded')) {
            currentInput.classList.remove('max-exceeded');
        }

        // show user when they've reached the limit
        if(currentValue.length === max) {
            currentInput.classList.add('max-exceeded');
        }
    }
  
    //if the engraving text has been deleted and length is now 0, we disable the atc button again
    if(currentValue.length == 0) {
		addToCartBtn.disabled = true;
        addToCartBtn.classList.add('disable');
    
        mobileAdddToCartBtn.disabled = true;
        mobileAdddToCartBtn.classList.add('disable');    
 	 }
}

const engraveInputs = document.querySelectorAll('input.engrave');
const productForm = document.querySelector('form.product_form');

productForm.addEventListener('keydown', e => {
    const profanityExists = document.querySelectorAll('input[data-contains-profanity="true"]').length;
    // if you use the enter key in the form submission...
    if(e.keyCode === 13) {
       // check to make sure neither of the inputs have profanity in them
        if(profanityExists) {
            // if they do, disable the enter button
            e.preventDefault();
        }
    }
});


const addToCartBtn = document.querySelector('#AddToCart');
const mobileAdddToCartBtn = document.querySelector('.mob_addtocart_btn button[type="submit"]');

addToCartBtn.addEventListener('click', e => {
    const profanityExists = document.querySelectorAll('input[data-contains-profanity="true"]').length;
       // check to make sure neither of the inputs have profanity in them
        if(profanityExists) {
            // if they do, disable the enter button
            e.preventDefault();
        }
});

mobileAdddToCartBtn.addEventListener('click', e => {
    const profanityExists = document.querySelectorAll('input[data-contains-profanity="true"]').length;
       // check to make sure neither of the inputs have profanity in them
        if(profanityExists) {
            // if they do, disable the enter button
            e.preventDefault();
        }
});

// add event handler on type
for (const input of engraveInputs) {
    input.addEventListener('input', engraveTypeHandler);
  
 	//disable add to cart buttons on load because engrave input box will be empty
    const addToCartBtn = document.querySelector('#AddToCart');
    const mobileAdddToCartBtn = document.querySelector('.mob_addtocart_btn button[type="submit"]');
      
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('disable');

    mobileAdddToCartBtn.disabled = true;
    mobileAdddToCartBtn.classList.add('disable');
}




